import referralService from '../services/referralService';

/**
 * Fetch referral rules
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const getReferralRules = async () => {
    try {
        const response = await referralService.getReferralRules();
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.message };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Fetch current bonuses for the user
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const getMyCurrentBonuses = async () => {
    try {
        const response = await referralService.getMyCurrentBonuses();
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.message };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Fetch bonus history for the user
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const getMyBonusHistory = async (params = {}) => {
    try {
        const response = await referralService.getMyBonusHistory(params);
        if (response.success) {
            return { success: true, data: response };
        } else {
            return { success: false, error: response.message };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Fetch referral amount
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const getReferralAmount = async () => {
    try {
        const response = await referralService.getReferralAmount();
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.message };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

